import { limitNumberPrecision } from '@/utils/general/limitNumberPrecision'

const IMPACT_PRECISION = 4

// U+00A0, spelled with a char code so the source carries no invisible
// whitespace. The digraph renders absolute impact inside a narrow grid cell,
// where an ordinary space puts "pp" on its own line.
const NON_BREAKING_SPACE = String.fromCharCode(160)

/**
 * Absolute impact is a difference between two probabilities, so it reads in
 * percentage points, not percent. Shared by the digraph and Diagnosis so the
 * same pair never prints two different-looking numbers (KBE-811).
 */
export function formatAbsoluteImpact(value: number): string {
  return `${limitNumberPrecision(value * 100, IMPACT_PRECISION)}${NON_BREAKING_SPACE}pp`
}

/**
 * Relative impact is a multiple of the baseline probability — unbounded, and not
 * a percentage. It used to print as `value * 100` with a `%` sign on the
 * Diagnosis page while the digraph printed the raw ratio, which made identical
 * numbers look 100x apart.
 */
export function formatRelativeImpact(value: number): string {
  return `×${limitNumberPrecision(value, IMPACT_PRECISION)}`
}
